/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_GoalInputs */

const en_lg_search_goal = /** @type {(inputs: Lg_Search_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find messages in channels, DMs, groups, or threads you can still read, without moving around or joining an office room.`)
};

const id_lg_search_goal = /** @type {(inputs: Lg_Search_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan pesan dari channel, DM, grup, atau thread yang masih dapat kamu baca, tanpa berpindah atau bergabung ke ruang kantor.`)
};

/**
* | output |
* | --- |
* | "Find messages in channels, DMs, groups, or threads you can still read, without moving around or joining an office room." |
*
* @param {Lg_Search_GoalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_goal = /** @type {((inputs?: Lg_Search_GoalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_GoalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_goal(inputs)
	return en_lg_search_goal(inputs)
});